/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';

type Props = {
  onPress: () => void;
};

export function AiAssistantBanner({ onPress }: Props) {
  return (
    <TouchableOpacity style={styles.banner} onPress={onPress} activeOpacity={0.9}>
      <View style={styles.iconWrap}>
        <Ionicons name="sparkles" size={20} color={'#fff'} />
      </View>
      <View style={styles.textWrap}>
        <Text style={styles.title}>Preguntá a tu asistente</Text>
        <Text style={styles.subtitle}>Consultá ventas, stock, precios y más.</Text>
      </View>
      <Ionicons name="chevron-forward" size={18} color={ticketColors.gold} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    marginHorizontal: spacing.md,
    marginTop: spacing.md,
    padding: spacing.md,
    borderRadius: 14,
    backgroundColor: '#e8f6f4',
    borderWidth: 1,
    borderColor: '#bfe7e2',
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textWrap: { flex: 1, minWidth: 0 },
  title: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  subtitle: {
    fontSize: 13,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    marginTop: 2,
  },
});
